import { useState, useEffect } from "react";
import { workshopApi } from "../../../services/workshopApi";

/**
 * Custom hook to fetch upcoming workshops (starting soon)
 *
 * @param {number} limit - Number of upcoming workshops to fetch
 * @returns {Object} { upcomingWorkshops, loading, error, refetch }
 */
function useUpcomingWorkshops(limit = 10) {
  const [upcomingWorkshops, setUpcomingWorkshops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUpcoming = async () => {
    try {
      setLoading(true);
      setError(null);

      // Use the main workshops endpoint with specific filters for upcoming
      const response = await workshopApi.getWorkshops({
        status: "upcoming",
        sortBy: "startDate",
        sortOrder: "asc",
        limit: limit,
        page: 1,
      });

      if (response.success) {
        setUpcomingWorkshops(response.data.workshops || []);
      } else {
        setError(
          new Error(response.message || "Failed to fetch upcoming workshops")
        );
      }
    } catch (err) {
      setError(err);
} finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUpcoming();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit]);

  return {
    upcomingWorkshops,
    loading,
    error,
    refetch: fetchUpcoming,
  };
}

export default useUpcomingWorkshops;
